var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmPopUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1793_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 0C21.756 0 0 21.756 0 48.5C0 75.244 21.756 97 48.5 97C75.244 97 97 75.244 97 48.5C97 21.756 75.244 0 48.5 0Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0819 38.2223L46.8108 64.4926C46.0226 65.2808 44.9881 65.6774 43.9535 65.6774C42.9189 65.6774 41.8843 65.2808 41.0961 64.4926L27.961 51.3574C26.3802 49.7774 26.3802 47.2228 27.961 45.6428C29.541 44.062 32.0949 44.062 33.6756 45.6428L43.9535 55.9206L67.3672 32.5076C68.9472 30.9268 71.5011 30.9268 73.0819 32.5076C74.6619 34.0876 74.6619 36.6415 73.0819 38.2223Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1793_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPopUp);
export default __webpack_public_path__ + "static/media/confirm_pop_up.2849618bbf662247799f2c8a0ba51d75.svg";
export { ForwardRef as ReactComponent };